import React from "react";
import { Box, Button, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { inputSx, primaryButtonSx } from "../accountStyles";



function PasswordField({ label, value, onChange, shown, onToggle, error, helperText }) {
  return (
    <TextField
      label={label}
      fullWidth
      type={shown ? "text" : "password"}
      autoComplete="new-password"
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      sx={inputSx}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={onToggle} edge="end" size="small" aria-label={shown ? "Hide password" : "Show password"}>
              {shown ? <VisibilityOff sx={{ fontSize: 18 }} /> : <Visibility sx={{ fontSize: 18 }} />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export default function PasswordForm({
  password,
  onPasswordChange,
  passwordConfirm,
  onPasswordConfirmChange,
  showPassword,
  onToggleShowPassword,
  showConfirmPassword,
  onToggleShowConfirmPassword,
  submitted,
  onSave,
}) {
  return (
    <Box component="form" noValidate onSubmit={(e) => e.preventDefault()}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6}>
          <PasswordField
            label="New Password"
            value={password}
            onChange={onPasswordChange}
            shown={showPassword}
            onToggle={onToggleShowPassword}
            error={submitted && !password}
            helperText={submitted && !password ? "Please enter a new password" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PasswordField
            label="Confirm New Password"
            value={passwordConfirm}
            onChange={onPasswordConfirmChange}
            shown={showConfirmPassword}
            onToggle={onToggleShowConfirmPassword}
            error={submitted && !passwordConfirm}
            helperText={submitted && !passwordConfirm ? "Please confirm your password" : ""}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Button onClick={onSave} variant="contained" disableElevation sx={{ ...primaryButtonSx, width: { xs: "100%", sm: "auto" }, minWidth: { sm: 240 } }}>
          Update Password
        </Button>
      </Box>
    </Box>
  );
}
